import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

export function dayjsToApiString(date: dayjs.Dayjs) {
  // @ts-expect-error TS7053: Element implicitly has an any type
  if (date._dateschema === 'date') {
    return date.local().format('YYYY-MM-DD')
  }
  return date.local().format('YYYY-MM-DDTHH:mm:ss')
}

export function initDayjs() {
  // export types for pilets see typings.export.d.ts
  dayjs.extend(duration)
  dayjs.extend(relativeTime)
  dayjs.extend(timezone)
  dayjs.extend(utc)
  dayjs.tz.setDefault('Europe/Vienna')
  dayjs.prototype.toJSON = function () {
    return dayjsToApiString(this)
  }
}
